import {
  DialogContent as DialogContentComponent,
  DialogActions as DialogActionsComponent,
  Button as ButtonComponent,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export type TileProps = {
  selected: string;
};

export const DialogContent = lib.styled(DialogContentComponent)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 20px;
`;

export const Tile = lib.styled.div<TileProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    background: ${(props: TileProps) =>
      props.selected ? colors.lightBlue : colors.white02};
    border: 2px solid ${(props: TileProps) =>
      props.selected ? colors.lightBlue : colors.lightGray};
    border-radius: 10px;
    padding: 10px;
    width: 220px;
    height: 190px;
    cursor: pointer;
    

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 10px;
    }

    span {
        font-weight: bold;
        font-size: 14px;
        width: 200px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${(props: TileProps) =>
          props.selected ? colors.white : colors.black};
    }

    :hover {
        background: ${colors.lightBlue};
        border: 2px solid ${colors.lightBlue};
        color: ${colors.white};
    }
`;

export const DialogTitle = lib.styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px 10px 20px;

    #subTitle {
        font-weight: bold;
        color: ${colors.darkGray02};
    }
`;

export const DialogActions = lib.styled(DialogActionsComponent)`
    margin: 8px;
`;

export const Button = lib.styled(ButtonComponent)`
  &.MuiButton-containedPrimary {
    background-color: ${colors.lightBlue}!important;
  }
`;
